import {
    AnimationTriggerMetadata,
    trigger,
    state,
    transition,
    style,
    animate,
    keyframes
} from '@angular/animations';

export const toastAnimations: {
    readonly fadeToast: AnimationTriggerMetadata;
} = {
    fadeToast: trigger('flyInOut', [
        state('default', style({
            opacity: 1,
        })),
        transition('void => *', animate('{{ fadeIn }}ms ease-out', keyframes([
            style({
                transform: 'translate3d(100%, 0, 0) skewX(-45deg)',
                opacity: 0,
            }),
            style({
                transform: 'skewX(35deg)',
                opacity: 1,
            }),
            style({
                transform: 'skewX(-10deg)',
                opacity: 1,
            }),
            style({
                transform: 'none',
                opacity: 1,
            }),
        ]))),
        transition('default => closing', animate('{{ fadeOut }}ms ease-out', keyframes([
            style({
                opacity: 1,
            }),
            style({
                transform: 'translate3d(100%, 0, 0) skewX(45deg)',
                opacity: 0,
            }),
        ]))),
    ]),
};

export type ToastAnimationState = 'default' | 'closing';
